module.exports = __webpack_public_path__ + "static/media/btn-arrow-gradeinte-o.f25703b4.svg";